import { render, staticRenderFns } from "./YsTableList.vue?vue&type=template&id=6efbfb2c&scoped=true"
import script from "./YsTableList.vue?vue&type=script&lang=js"
export * from "./YsTableList.vue?vue&type=script&lang=js"
import style0 from "./YsTableList.vue?vue&type=style&index=0&id=6efbfb2c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6efbfb2c",
  null
  
)

export default component.exports